import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from "@material-ui/icons/Help";

interface PropTypes {
  total: number;
  nbrLabelisees: number;
  onHelpClicked?: any;
}

const Progress = ({ total, nbrLabelisees, onHelpClicked }: PropTypes) => {
  return (
    <Grid
      container
      direction="row"
      spacing={0}
      alignItems="baseline"
      justify={"space-between"}
    >
      <Grid item xs={onHelpClicked ? 10 : 12}>
        <LinearProgress
          variant="determinate"
          color="primary"
          value={(nbrLabelisees * 100) / total}
        />
        <Typography style={{ paddingTop: 8 }}>
          Nombre d'images labellisées :{" "}
          <strong>
            {nbrLabelisees}/{total}
          </strong>
        </Typography>
      </Grid>
      {onHelpClicked && (
        <Grid
          item
          xs={1}
          style={{
            display: "flex",
            justifyContent: "end"
          }}
        >
          <IconButton
            onClick={onHelpClicked}
            style={{ padding: "8px" }}
          >
            <HelpIcon color="primary" />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default Progress;
